//import { url } from "inspector";
import { END_POINTS } from "../helpers";
// import { any } from "../types/NewOrder";
import emptySplitApi from "../utils/rtk";
import { CommonBody } from "../types/General";
type CommonResponseType = {
  statusCode: number;
  message: string;
};
type GetAllNewOrderResponse = {
  data: any;
  // NewOrder: any[];
  count: number;
};

type GetTokenParams = {
  // limit?: number;
  // wpagination?:boolean;
  type?: number;
  page?: number;
  query?: string;
};
// type EditUserById = {
//     image: string;
//     email: string;
//     fullName: string;
//     countryCode: string;
//     phone: string;
//     address:string;
//   };

export const userApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getNewOrder: builder.query<
      CommonResponseType & { data: any },
      GetTokenParams
    >({
      // query:({page,limit,query})=>{
      query: ({ page, type, query }) => {
        let url = END_POINTS.newOrders;
        const queryParams = [];
        if (page) {
          queryParams.push("wpagination=true");
        }
        // if (query) {
        //   queryParams.push(`search=${query}`);
        // }
        if (type) {
          queryParams.push(`type=${type}`);
        }
        if (queryParams.length > 0) {
          url += `?${queryParams.join("&")}`;
        }
        return {
          url: url,
          method: "GET",
        };
      },
    }),

    getNewOrderById: builder.query<
      CommonResponseType & { data: any },
      { id: string | undefined }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.newOrders}/${id}`,
        method: "GET",
      }),
    }),
    editNewOrderById: builder.mutation<
      CommonResponseType & { data: any },
      { id: string; body: any }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.newOrders}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    getPassengerFlight: builder.query<
      CommonResponseType & { data: any },
      GetTokenParams
    >({
      // query:({page,limit,query})=>{
      query: ({ page, type, query }) => {
        let url = END_POINTS.passenger;
        const queryParams = [];
        if (page) {
          queryParams.push("wpagination=true");
        }
        // if (query) {
        //   queryParams.push(`search=${query}`);
        // }
        if (type) {
          queryParams.push(`type=${type}`);
        }
        if (queryParams.length > 0) {
          url += `?${queryParams.join("&")}`;
        }
        return {
          url: url,
          method: "POST",
        };
      },
    }),

    getFeedback: builder.query<
      CommonResponseType & { data: any },
      GetTokenParams
    >({
      query: ({ page, type, query }) => {
        let url = END_POINTS.feedback;
        const queryParams = [];
        if (page) {
          queryParams.push("wpagination=true");
        }
        if (query) {
          queryParams.push("page=1");
        }
        if (type) {
          queryParams.push(`type=${type}`);
        }
        if (query) {
          queryParams.push(`query=${query}`);
        }
        if (queryParams.length > 0) {
          url += `?${queryParams.join("&")}`;
        }
        return {
          url: url,
          method: "GET",
        };
      },
    }),
    editPassengerFlightById: builder.mutation<
      CommonResponseType & { data: any },
      { id: string; body: any }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.passengerFlight}/${id}`,
        method: "PUT",
        body,
      }),
    }),
  }),
});
export const {
  useLazyGetNewOrderQuery,
  useLazyGetNewOrderByIdQuery,
  useEditNewOrderByIdMutation,
  useLazyGetPassengerFlightQuery,
  useLazyGetFeedbackQuery,
  useGetFeedbackQuery,
  useEditPassengerFlightByIdMutation,
} = userApi;
